export const ROUTES = {
  Home: "/",
  About: "/about",
  Links: "/links",
  Date: "qwerty/surprise",
};
